/** KKPPをIDPとする金融機関コード一覧 */
const KKPP_BANK_CODE: { value: string }[] = [
  { value: '0117' }, // 青森みちのく銀行
  { value: '0121' }, // 荘内銀行
  { value: '0123' }, // 岩手銀行
  // { value: '0125' }, // 七十七銀行
  { value: '0126' }, // 東邦銀行
  // { value: '0129' }, // 足利銀行
  { value: '0130' }, // 常陽銀行
  // { value: '0134' }, // 千葉銀行
  { value: '0143' }, // 八十二銀行
  // { value: '0144' }, // 北陸銀行
  { value: '0147' }, // 福井銀行
  // { value: '0158' }, // 京都銀行
  // { value: '0159' }, // 関西みらい銀行
  // { value: '0161' }, // 池田泉州銀行
  { value: '0163' }, // 紀陽銀行
  { value: '0164' }, // 但馬銀行
  // { value: '0167' }, // 山陰合同銀行
  // { value: '0174' }, // 伊予銀行
  { value: '0175' }, // 四国銀行
  { value: '0179' }, // 佐賀銀行
  { value: '0182' }, // 肥後銀行
  { value: '0183' }, // 大分銀行
  { value: '0184' }, // 宮崎銀行
  // { value: '0188' }, // 沖縄銀行
  // { value: '0190' }, // 西日本シティ銀行
  { value: '0501' }, // 北洋銀行
  { value: '0509' }, // 北日本銀行
  { value: '0512' }, // 仙台銀行
  // { value: '0513' }, // 福島銀行
  { value: '0516' }, // 東和銀行
  { value: '0517' }, // 栃木銀行
  { value: '0525' }, // 東日本銀行
  { value: '0532' }, // 大光銀行
  // { value: '0533' }, // 長野銀行
  // { value: '0537' }, // 福邦銀行
  { value: '0542' }, // あいち銀行
  { value: '0543' }, // 名古屋銀行
  { value: '0566' }, // トマト銀行
  { value: '0576' }, // 愛媛銀行
  { value: '0578' }, // 高知銀行
  { value: '0582' }, // 福岡中央銀行
  { value: '0585' }, // 長崎銀行
  { value: '0594' }, // 南日本銀行
  { value: '0596' }, // 沖縄海邦銀行
  { value: '1240' }, // 水戸信用金庫
  { value: '1253' }, // 飯能信用金庫
  { value: '1260' }, // 千葉信用金庫
  { value: '1280' }, // 横浜信用金庫
  { value: '1283' }, // 川崎信用金庫
  { value: '1286' }, // 平塚信用金庫
  { value: '1320' }, // 東京東信用金庫
  { value: '1341' }, // 西武信用金庫
  { value: '1360' }, // 多摩信用金庫
  { value: '1370' }, // 新潟信用金庫
  { value: '1373' }, // 三条信用金庫
  { value: '1385' }, // 甲府信用金庫
  { value: '1393' }, // 諏訪信用金庫
  { value: '1396' }, // アルプス中央信用金庫
  { value: '1440' }, // 金沢信用金庫
  { value: '1470' }, // 福井信用金庫
  { value: '1502' }, // 静清信用金庫
  // { value: '1530' }, // 岐阜信用金庫
  { value: '1532' }, // 高山信用金庫
  { value: '1533' }, // 東濃信用金庫
  { value: '1557' }, // 豊川信用金庫
  { value: '1560' }, // 碧海信用金庫
  // { value: '1583' }, // 桑名三重信用金庫
  { value: '1602' }, // 滋賀中央信用金庫
  { value: '1636' }, // 大阪商工信用金庫
  { value: '1668' }, // 奈良中央信用金庫
  { value: '1674' }, // きのくに信用金庫
  { value: '1685' }, // 姫路信用金庫
  { value: '1692' }, // 但馬信用金庫
  { value: '1738' }, // 玉島信用金庫
  { value: '1752' }, // 呉信用金庫
  { value: '1991' }, // 鹿児島相互信用金庫
  { value: '1996' }, // コザ信用金庫
  { value: '2010' }, // 全国信用協同組合連合会
  { value: '2360' }, // 協栄信用組合
  { value: '2680' } // 広島市信用組合
];
const bamidpTokenKey = 'auth._token.bamidp';
const tokenPrefix = 'auth._token.bamidp_bank';
const strategyKey = 'auth.strategy';

// ローカルストレージに有効なトークンが存在するかチェック
export const checkLocalStorage = (): boolean => {
  const isTokenInvalid = (key: string): boolean => {
    const token = localStorage.getItem(key);
    return !token || token === 'false';
  };

  // デフォルトストラテジーであるbamidpをチェック
  if (isTokenInvalid(bamidpTokenKey)) {
    // 存在しない場合はkkpp用に実装したストラテジーをチェック
    const hasValidKKPPToken = KKPP_BANK_CODE.some(codeObj => {
      const bankCode = codeObj.value;
      return !isTokenInvalid(`${tokenPrefix}${bankCode}`);
    });

    // 全てのストラテジーが無効な場合はtrue
    return !hasValidKKPPToken;
  }

  // デフォルトトークンが有効な場合は false を返す
  return false;
};

// IdTokenの取得
export const getIdToken = (): string => {
  const getToken = (key: string): string | null => {
    const token = localStorage.getItem(key);
    return token && token !== 'false' ? token : null;
  };

  // bamidpのトークンが存在する場合はそれを返す
  const bamidpToken = getToken(bamidpTokenKey);
  if (bamidpToken) {
    return bamidpToken;
  }

  // 存在しない場合はkkpp用に実装したストラテジーをチェック
  for (const codeObj of KKPP_BANK_CODE) {
    const bankCode = codeObj.value;
    const bankToken = getToken(`${tokenPrefix}${bankCode}`);
    if (bankToken) {
      return bankToken;
    }
  }

  // どちらのトークンも存在しない場合は空文字を返す
  return '';
};

// nuxt/authのstrategyを設定
export const setStrategy = (bankCode: string): string => {
  for (const codeObj of KKPP_BANK_CODE) {
    if (codeObj.value === bankCode) {
      return `bamidp_bank${bankCode}`;
    }
  }
  return 'bamidp';
};

// BA-KKPPを使用している金融機関か判定
export const isKKPP = (bankCode: string): boolean => {
  return KKPP_BANK_CODE.some(codeObj => codeObj.value === bankCode);
};

/**
 * strategyからBA-KKPPを使用している金融機関か判定
 */
export const isKKPPFromStrategy = (): boolean => {
  const strategy = localStorage.getItem(strategyKey);
  if (!strategy) {
    return false;
  }
  return KKPP_BANK_CODE.some(codeObj => strategy === `bamidp_bank${codeObj.value}`);
};
